<template>
  <DxTreeList ref="treeList" :data-source="dsClase" key-expr="ID" parent-id-expr="ParentID" :root-value="null"
    :show-borders="true" :column-auto-width="true" :word-wrap-enabled="true" @selection-changed="onSelectionChanged"
    :allow-column-reordering="true" column-resizing-mode="nextColumn" :filter-sync-enabled="true" :show-row-lines="true"
    :show-column-lines="false" :selected-row-keys="selectedRowKeys" :hover-state-enabled="true"
    @content-ready="applyRouteSelection">
    <DxSelection mode="single" :auto-expand-all="false" :expanded-row-keys="expandedRowKeys" />
    <DxPaging :enabled="true" :page-size="10" />
    <DxPager :show-page-size-selector="true" :allowed-page-sizes="allowedPageSizes" :show-info="true" />
    <DxSearchPanel :visible="true" :width="250" />
    <DxToolbar>
      <DxItem name="searchPanel" location="before" />
      <DxItem location="after">
        <template #default>
          <DxButton icon="add" @click="onAddClick()" />
        </template>
      </DxItem>
      <DxItem location="after">
        <template #default>
          <DxButton icon="refresh" @click="onRefreshClick" />
        </template>
      </DxItem>
    </DxToolbar>
    <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
      <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="410">
        <DxToolbarItem :template="customTitleTemplate" />
        <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
        <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
      </DxPopup>
      <DxFormGrid :colCount="2">
        <DxItem :col-span="2" :col-count="2" item-type="group" :onFieldDataChanged="onFieldDataChanged">
          <DxItem data-field="Cod" :editor-options="{ width: 250, placeholder: 'ex: Tablete' }" />
          <DxItem data-field="Nume" :editor-options="{ width: 250, placeholder: 'ex: Tablete' }" />

          <DxItem data-field="ParentID" editor-type="dxSelectBox" :editor-options="{
            dataSource: claseOptions,
            valueExpr: 'ID',
            displayExpr: 'NumeArborescent',
            searchEnabled: true,
            showClearButton: true,
            width: 250,
            placeholder: 'Selectează'
          }" :label="{ text: 'Clasa Părinte' }" />

          <DxItem data-field="Nivel" :editor-options="{ width: 250, readOnly: true }" />
          <DxItem data-field="IndexNod" :editor-options="{ width: 250, showSpinButtons: true }"
            editor-type="dxNumberBox" />
          <DxItem data-field="NumeArborescent" :editor-options="{ width: 250, readOnly: true }" />

          <DxItem data-field="WwwID" :editor-options="{ width: 250, showSpinButtons: true }"
            editor-type="dxNumberBox" />
          <DxItem data-field="WwwSyncedDate" editor-type="dxDateBox"
            :editor-options="{ width: 250, type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ', useMaskBehavior: true }" />
        </DxItem>
      </DxFormGrid>
    </DxEditing>
    <DxColumn data-field="Cod" />
    <DxColumn data-field="Nume" />
    <DxColumn data-field="ID" :visible="false" />
    <DxColumn data-field="Nivel" :visible="false" />
    <DxColumn data-field="IndexNod" :visible="false" />
    <DxColumn data-field="NumeArborescent" :visible="false" />
    <DxColumn data-field="ParentID" :visible="false" />
    <DxColumn data-field="WwwID" :visible="false" />
    <DxColumn data-field="WwwSyncedDate" :visible="false" />
  </DxTreeList>
  <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
    :width="600" :height="400">
    <template #title>
      <div style="background-color:#ff2c21;font-size:15px;color:white;font-weight:bold;padding:10px 0 10px 20px;">
        Adăugare
      </div>
    </template>

    <div>
      <DxForm :formData="formData" :colCount="2" :onFieldDataChanged="onFieldDataChanged">
        <DxItem data-field="Cod" :editor-options="{ width: 250, placeholder: 'ex: Tablete' }" />
        <DxItem data-field="Nume" :editor-options="{ width: 250, placeholder: 'ex: Tablete' }" />

        <DxItem data-field="ParentID" editor-type="dxSelectBox" :editor-options="{
          dataSource: claseOptions,
          valueExpr: getValueExpr,
          displayExpr: getDisplayExpr,
          searchEnabled: true,
          showClearButton: true,
          width: 250,
          onValueChanged: onParentChanged,
          placeholder: 'Selectează'
        }" :label="{ text: 'Clasa Părinte' }" />
        <DxItem data-field="Nivel" :editor-options="{ width: 250, readOnly: true }" />
        <DxItem data-field="IndexNod" :editor-options="{ width: 250, showSpinButtons: true }"
          editor-type="dxNumberBox" />
        <DxItem data-field="NumeArborescent" :editor-options="{ width: 250, readOnly: true }" />
        <DxItem data-field="WwwID" :editor-options="{ width: 250, showSpinButtons: true }" editor-type="dxNumberBox" />
        <DxItem data-field="WwwSyncedDate" editor-type="dxDateBox"
          :editor-options="{ width: 250, type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm' }" />
      </DxForm>

      <div style="display:flex;justify-content:flex-end;gap:8px; margin-top: 25px;">
        <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
        <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
      </div>
    </div>
  </DxPopupAdd>

</template>

<script lang="ts">
import DxSelectBox from "devextreme-vue/select-box"
import { DxButton } from 'devextreme-vue/button';
import { defineComponent } from 'vue';
import CustomStore from 'devextreme/data/custom_store';
import { DataSource } from 'devextreme/common/data';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm } from 'devextreme-vue/form';
import DxDataGrid from 'devextreme-vue/data-grid';
import {
  DxTreeList,
  DxColumn,
  DxSearchPanel,
  DxSelection,
  DxPaging,
  DxPager,
  DxEditing,
  DxPopup,
  DxForm as DxFormGrid,
  DxItem as DxItemForm,
  DxToolbar,
} from 'devextreme-vue/tree-list';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import PRO_Clase from "@/services/PRO/PRO_Clase";
export default defineComponent({
  components: {
    DxTreeList,
    DxColumn,
    DxSearchPanel,
    DxSelection,
    DxPaging,
    DxPager,
    DxEditing,
    DxPopup,
    DxPopupAdd,
    DxToolbarItem,
    DxFormGrid,
    DxItemForm,
    DxItem,
    DxToolbar,
    DxButton,
    DxForm,
    DxDataGrid,
    DxSelectBox,
  },
  data() {
    return {
      dsClase: {} as CustomStore,
      allowedPageSizes: [],
      isModalVisible: false,
      claseById: new Map(),
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      claseOptions: [],
      selectedRowKeys: [],
      expandedRowKeys: [] as string[],
      formData: {
        Nume: '',
        Cod: '',
        ParentID: null,
        Nivel: 0,
        IndexNod: 0,
        NumeArborescent: '',
        WwwID: null,
        WwwSyncedDate: null
      },

      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
          <div style="background-color: #ff2c21; font-size: 15px; float: right; height:47px; width:665px; color: white; 
          font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
      },
    };
  },
  emits: ['selection-changed'],
  watch: {
    '$route.params.id'(newId) {
      // dacă vine prin back/forward și e alt ID, reaplică selecția
      if (!newId || this.selectedRowKeys[0] === newId) return
      this.applyRouteSelection()
    }
  },
  methods: {
    applyRouteSelection() {
      const id = this.$route.params.id
      if (!id) return

      this.selectedRowKeys = [id]

      this.$nextTick(() => {
        const tree = this.$refs.tree?.instance
        if (!tree) return

        tree.selectRows([id], false)

      })
    },

    async loadClase() {
      const resp = await fetch(`${AppSetting.API_Url_ComercialOdata}PRO_Clase`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
          Accept: 'application/json'
        }
      });
      if (!resp.ok) {
        console.error('Eroare la încărcare PRO_Clase', resp.status, await resp.text());
        return;
      }
      const json = await resp.json();
      const data = Array.isArray(json) ? json : (json.value ?? []);
      this.claseOptions = data;
      this.claseById = new Map(data.map(x => [(x.ID ?? x.Id ?? x.id), x]));

    },
    createStore() {
      const baseUrl = `${AppSetting.API_Url_ComercialOdata}PRO_Clase`;
      const auth = () => 'Bearer ' + localStorage.getItem('ERA_Jwt');

      const store = new CustomStore({
        key: 'ID',
        loadMode: 'raw',

        load: async () => {
          const resp = await fetch(baseUrl, {
            headers: {
              'Authorization': auth(),
              'Accept': 'application/json'
            }
          });
          if (!resp.ok) throw new Error('Eroare la încărcare');
          const json = await resp.json();
          const data = Array.isArray(json) ? json : (json.value ?? []);
          this.claseById = new Map(data.map(x => [x.ID, x]));
          return data;
        },

        update: async (key, values) => {
          const resp = await fetch(`${baseUrl}/${key}`, {
            method: 'PATCH',
            headers: {
              'Authorization': auth(),
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
          });
          if (!resp.ok) throw new Error(await resp.text());
          return true;
        },

        remove: async (key: any): Promise<void> => {
          const resp = await fetch(`${baseUrl}(${encodeURIComponent(key)})`, {
            method: 'DELETE',
            headers: {
              'Authorization': auth()
            }
          });
          if (!resp.ok) throw new Error('Eroare la ștergere');

          this.claseById?.delete(key);

        }
      });

      this.dsClase = new DataSource({
        store,
        paginate: false
      });
    },

    onFieldDataChanged(e) {
      if (e?.dataField) this.formData[e.dataField] = e.value;
      if (!e?.component) return;
      const form = e.component;
      if (e.dataField === 'Nume' || e.dataField === 'ParentID') {
        const fd = form.option('formData') || {};
        const parent = fd.ParentID ? this.getParent(fd.ParentID) : null;

        const nivel = parent ? ((parent.Nivel ?? 0) + 1) : 0;
        form.updateData('Nivel', nivel);

        const prefix = (parent?.NumeArborescent && parent.NumeArborescent.trim().length
          ? parent.NumeArborescent
          : parent?.Nume) || '';
        const selfName = (fd.Nume || '').trim();

        form.updateData(
          'NumeArborescent',
          prefix ? (selfName ? `${prefix} > ${selfName}` : `${prefix} >`) : selfName
        );
      }
    },
    onParentChanged(e) {
      const form = this.$refs.editForm?.instance;
      if (!form) return;

      const parentId = e.value ?? null;
      const parent = parentId ? this.getParent(parentId) : null;
      const nivel = parent ? ((parent.Nivel ?? 0) + 1) : 0;

      form.updateData('ParentID', parentId);
      form.updateData('Nivel', nivel);

      const fd = form.option('formData') || {};
      const prefix = (parent?.NumeArborescent && parent.NumeArborescent.trim().length
        ? parent.NumeArborescent
        : parent?.Nume) || '';
      const selfName = (fd.Nume || '').trim();

      form.updateData(
        'NumeArborescent',
        prefix ? (selfName ? `${prefix} > ${selfName}` : `${prefix} >`) : selfName
      );
    },

    getParent(id) {
      if (this.claseById.size) return this.claseById.get(id) ?? null;

      const items = this.dsClase?.items?.() ?? [];
      return items.find(x => x.ID === id) ?? null;
    },
    getValueExpr(item) {
      return item ? (item.ID) : null;
    },
    getDisplayExpr(item) {
      if (!item) return '';
      const name = item.Nume ?? '';
      const path = (item.NumeArborescent ?? '').trim();
      return path.length ? path : name;
    },
    onSaveAdd() {
      if (!this.formData.Nume || this.formData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1500);
        return;
      }

      const body = { ...this.formData };

      PRO_Clase.save(body)
        .then(() => {
          this.isModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1500);
          this.formData = {
            Nume: '',
            Cod: '',
            ParentID: null,
            Nivel: 0,
            IndexNod: 0,
            NumeArborescent: '',
            WwwID: null,
            WwwSyncedDate: null
          };
          this.createStore();
        })
        .catch((error) => {
          notify('Numele există deja pentru clasa părinte', 'error', 2000);
        });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    onSelectionChanged(e) {
      const row = e.selectedRowsData?.[0]
      if (row?.ID) {
        this.$router.replace({ name: 'Clase', params: { id: row.ID } })
        this.$emit('selection-changed', row)
      }
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.treeList?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onSaveEdit() {
      const savePromise = this.$refs.treeList?.instance?.saveEditData();
      savePromise
        .then(() => {
          notify('Datele au fost salvate cu succes!', 'success', 1000);
        })
        .catch((error) => {
          notify('Eroare la salvarea datelor!', 'error', 1000);
        });
    },
    onCancelEdit() {
      this.$refs.treeList.instance?.cancelEditData()
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onRefreshClick() {
      this.createStore();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.treeList?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },

  },
  mounted() {
    this.applyRouteSelection()
    this.createStore();
    this.loadClase();
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped></style>
